import { useTranslation } from 'react-i18next';
import CustomSelect from '../../Forms/Element/CustomSelect';
import AppointmentStatus from './AppointmentStatus';

const AppointmentStatusSelect = (props) => {
  
  const { t } = useTranslation();
  const { value, onChange, error } = props;
  const options = [
    { value: AppointmentStatus.CANCELED, label: t('canceled') },
    { value: AppointmentStatus.COMPLETED, label: t('completed') },
    { value: AppointmentStatus.CONFIRMED, label: t('confirmed') },
    { value: AppointmentStatus.IN_PROGRESS, label: t('in_progress') },
    { value: AppointmentStatus.NO_SHOW, label: t('no_show') },
    { value: AppointmentStatus.SCHEDULED, label: t('scheduled') }
];

  return (
    <CustomSelect options={options} value={value} onChange={onChange} isClearable placeholder={t("select")} error={error}/>
  )
}

export default AppointmentStatusSelect;